import React from 'react';

const HelpCenter: React.FC = () => {
    return (
        <div style={{ padding: '20px' }}>
            <p><strong>🛠 Support</strong></p>
            <p>For issues, questions, or feedback, please submit a <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=Semqse-lFUi3r_fEqlRrKLX6cxkwiT5MomVnTWCmsohUM0JGRTFLNUczSlpEN0gxUzk2N1JFS0UwQS4u" target="_blank"><strong>Pricing App Support Request</strong></a> or email the team <a href="mailto:PricingAppSupport@blend360.com"><strong>PricingAppSupport@blend360.com</strong></a>.</p>
            <hr />
            <p><strong>📖 Process Documents &amp; User Guides</strong></p>
            <p>Find detailed guides and documentation for Original Deal Economics (ODE) &amp; Pricing processes:</p>
            <ul>
            <li><strong>Getting Started with ODE &amp; the New Pricing App</strong> &ndash; user guide &amp; training recording</li>
            <li><strong>Service Line &amp; Functions Lookup</strong> &ndash; Mapping to HubSpot Line Items</li>
            <li><strong>Minimum FTE Allocation Guide</strong></li>
            </ul>
            <p><a href="https://wgcp.sharepoint.com/:f:/s/DSXPricingTool/EurodmB5OcZNqodMgOhG1TkB1chi5Zx-uvsmQS7mLf9m9A?e=CS0XIL" target="_blank">ODE &amp; Pricing Processes and Guides</a></p>
        </div>
    );
};

export default HelpCenter;